import { render } from "./StreamForm.vue?vue&type=template&id=639f202c"
import script from "./StreamForm.vue?vue&type=script&lang=js"
export * from "./StreamForm.vue?vue&type=script&lang=js"

import exportComponent from "/Users/pedropuga/Documents/ITSON/ITSON-BACKEND/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__